import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Master APIs
//TODO: Brand APIs
//  Get Doctor Detail
export const pharmacyTransactonSettlement = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}pharmacy-transacton-settlement`, data,headers);
};
export const labTransactonSettlement = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-transacton-settlement`, data,headers);
};
export const consultTransactonSettlement = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}consult-transacton-settlement`, data,headers);
};
export const pharmacyVendorSettlementReport = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}pharmacy-vendor-settlement-report`, data,headers);
};
export const pharmacyAccountsReport = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}accounts-report`, data,headers);
};